import React from 'react';
import { Images } from '../../app-constants';
import ImageIcon from './image-icon';

const PausedWithBackground = () => (
  <ImageIcon src={Images.PausedWithBackground} alt="empty-data/" />
);

export default PausedWithBackground;
